import type { QueryClient } from "@tanstack/react-query";

import type { useTRPC } from "@/integrations/trpc/react";

/**
 * Targeted tournament query invalidation.
 *
 * Instead of `trpc.tournaments.pathFilter()` which nukes every tournament
 * query in the cache, these helpers invalidate only the queries affected by
 * a particular mutation category. This prevents a single score override from
 * re-fetching teams, directors, search results, etc.
 */

/** Invalidate match-related views: pools, playoffs, courts overview, overview, and division summary. */
export function invalidateMatchQueries(
  queryClient: QueryClient,
  trpc: ReturnType<typeof useTRPC>,
) {
  void queryClient.invalidateQueries(trpc.tournaments.getPools.pathFilter());
  void queryClient.invalidateQueries(trpc.tournaments.getPlayoffs.pathFilter());
  void queryClient.invalidateQueries(
    trpc.tournaments.courtOverview.pathFilter(),
  );
  void queryClient.invalidateQueries(
    trpc.tournaments.tournamentOverview.pathFilter(),
  );
  void queryClient.invalidateQueries(
    trpc.tournaments.getDivisionSummary.pathFilter(),
  );
  void queryClient.invalidateQueries(
    trpc.tournaments.getPoolNames.pathFilter(),
  );
}

/** Invalidate everything — use for rare structural mutations (create pools, create playoffs, etc.). */
export function invalidateAllTournamentQueries(
  queryClient: QueryClient,
  trpc: ReturnType<typeof useTRPC>,
) {
  void queryClient.invalidateQueries(trpc.tournaments.pathFilter());
}
